class ScrollToElement {
  constructor(triggerSelector, offset = 0) {
    this.triggers = document.querySelectorAll(triggerSelector);
    this.offset = offset; // offset in pixels
    this.init();
  }

  init() {
    this.triggers.forEach(trigger => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        const targetSelector = trigger.dataset.target;
        const target = document.querySelector(targetSelector);
        if (target) {
          this.scrollTo(target);
        }
      });
    });
  }

  scrollTo(element) {
    const elementTop = element.getBoundingClientRect().top + window.scrollY;
    const scrollPosition = elementTop - this.offset; // apply offset / safe area
    window.scrollTo({
      top: scrollPosition,
      behavior: "smooth"
    });
  }
}